import { articleCommentsApi } from "../../../Api/ArticleComments";
import { useContentComments } from "../useContentComments";

export function useArticleComments(articleId: number | undefined) {
    return useContentComments(articleId, articleCommentsApi, "article");
}
